import { Injectable } from "@angular/core";
import { AreaDataProvider } from "src/app/shared/providers/AreaDataProvider.provider";
import { RouteDataProvider } from "src/app/shared/providers/RouteDataProvider.provider";
import { EventType, EventData } from "../../../../shared/model/shared-model";
import { RegionProvider } from "../region.provider";
import { FrequencyProvider } from "../frequency.provider";
import { ChannelProvider } from "../channel.provider";
import { GeographyProvider } from "../geography.provider";
import { StateProvider } from "../state.provider";
import { CityProvider } from "../city.provider";
import { RewardProvider } from "../rewards.provider";
import { CampaignProvider } from "../campaign.provider";
import { SchemesProvider } from "../schemes.provider";
import { VisibilityProvider } from "../visibility.provider";
import { CartonProvider } from "../carton.provider";
import { TargetAchievementProvider } from "../target-achivement.provider";
import { RolesProvider } from "../roles.provider";
import { UnitsProvider } from "../units.provider";

@Injectable({
  providedIn: "root",
})
export class AdminDataProvider extends AreaDataProvider {
  currentAreaTitle: string = "Dashboard";
  video: any = [];
  constructor(
    routeDataProvider: RouteDataProvider,
    public regionProviders: RegionProvider,
    public frequencyProviders: FrequencyProvider,
    public geographyProviders: GeographyProvider,
    public channelProviders: ChannelProvider,
    public rewardProvider: RewardProvider,
    public campaignProvider: CampaignProvider,
    public schemesProvider: SchemesProvider,
    public visibilityProvider: VisibilityProvider,
    public cartonProvider: CartonProvider,
    public targetProvider: TargetAchievementProvider,
    public unitsProvider: UnitsProvider,
    public rolesProvider: RolesProvider,
    public stateProvider: StateProvider,
    public cityProvider: CityProvider
  ) {
    super("Admin", routeDataProvider);
  }

  areaChanged(newArea: string, firstCall: boolean) {
    if (firstCall) {
      return;
    }
  }

  subAreaChanged(newSubArea: string, firstCall: boolean) {
    if (firstCall || newSubArea == this.currentAreaName) {
      return;
    }
    this.eventHandler({ type: EventType.subAreaChanged });
  }

  queryParamChanged(newQueryParams: any, firstCall: boolean) {
    if (firstCall) {
      return;
    }
    if (newQueryParams.id !== undefined) {
      this.eventHandler({ type: EventType.queryParamChanged });
    } else {
      this.eventHandler({ type: EventType.areaChanged });
    }
  }

  urlMaker(data: any): string {
    return "";
  }

  eventHandler(eventData: EventData) {
    switch (eventData.type) {
      case EventType.queryParamChanged:
        // console.log("Query param changed", this.currentQueryParam);
        break;
      case EventType.subAreaChanged:
        console.log("Sub Area changed", this.currentSubAreaName);
        switch (this.currentSubAreaName) {
          case "region":
            this.currentAreaTitle = "Dashboard";
            this.regionProviders.getRegionList();
            break;
          case "states":
            this.currentAreaTitle = "State";
            this.regionProviders.getRegionList();
            break;
          case "brands":
            console.log("brands master calling...");
            this.currentAreaTitle = "Dashboard";
            this.regionProviders.getRegionList();
            break;
          case "reward-categories":
            this.currentAreaTitle = "Dashboard";
            this.rewardProvider.getRewardCategoryList();
            break;
          case "reward-sub-categories":
            this.currentAreaTitle = "Dashboard";
            this.rewardProvider.getRewardSubCategory();
            break;
          case "reward-history":
            this.currentAreaTitle = "Reward History";
            this.rewardProvider.getRewardHistory();
            break;
          case "reward-types":
            this.currentAreaTitle = "Reward Types";
            this.rewardProvider.getRewardTypeList();
            break;
          case "campaign":
            this.currentAreaTitle = "Dashboard";
            this.campaignProvider.getCampaignCount();
            this.campaignProvider.getCampaignList();
            this.regionProviders.getRegionList();
            this.stateProvider.getStateList();
            break;
          case "engagement":
            this.currentAreaTitle = "Engagement";
            this.channelProviders.getAllChannels();
            this.regionProviders.getRegionList();
            this.rolesProvider.getUserRoles();
            this.stateProvider.getStateList();
            // this.regionProviders.getAllCities();
            break;
          case "add_engagement":
            this.currentAreaTitle = "Add engagement";
            this.campaignProvider.getAllCampaigns();
            this.channelProviders.getAllChannels();
            this.regionProviders.getRegionList();
            this.rolesProvider.getUserRoles();
            this.stateProvider.getStateList();
            break;
          case "schemes-list":
            this.currentAreaTitle = "Schemes";
            this.schemesProvider.getSchemesList();
            break;
          case "scheme-configuration":
            this.currentAreaTitle = "Scheme configuration";
            this.regionProviders.getRegionList();
            this.frequencyProviders.getFrequencyList();
            this.channelProviders.getAllChannels();
            this.rolesProvider.getUserRoles();
            break;
          case "visibility-list":
            this.currentAreaTitle = "Visibility";
            this.visibilityProvider.getVisibilityList();
            break;
          case "cooler-element":
            this.currentAreaTitle = "Cooler Elements";
            this.visibilityProvider.getVisibilityList();
          case "visibility-config":
            this.frequencyProviders.getFrequencyList();
            this.visibilityProvider.getVisibilityList();
            break;
          case "visibility-config-list":
            this.currentAreaTitle = "Branding Configuration List";
            this.regionProviders.getRegionList();
            this.frequencyProviders.getFrequencyList();
            this.channelProviders.getAllChannels();
            this.geographyProviders.getGeographyList();
            this.visibilityProvider.getVisibilityList();
            break;
          case "cooler-config-list":
            this.currentAreaTitle = "Cooler Configuration List";
            this.regionProviders.getRegionList();
            this.frequencyProviders.getFrequencyList();
            this.channelProviders.getAllChannels();
            this.geographyProviders.getGeographyList();
            this.visibilityProvider.getVisibilityList();
            break;
          case "visibility-config-add":
            this.currentAreaTitle = "Branding Configuration List";
            this.regionProviders.getRegionList();
            this.frequencyProviders.getFrequencyList();
            this.channelProviders.getAllChannels();
            this.stateProvider.getStateList();
            this.geographyProviders.getGeographyList();
            this.visibilityProvider.getVisibilityList();
            break;
          case "cooler-config-add":
            this.currentAreaTitle = "Cooler Configuration List";
            this.regionProviders.getRegionList();
            this.frequencyProviders.getFrequencyList();
            this.channelProviders.getAllChannels();
            this.stateProvider.getStateList();
            this.geographyProviders.getGeographyList();
            this.visibilityProvider.getVisibilityList();
            break;
          case "carton-list":
            this.currentAreaTitle = "Cartons";
            this.cartonProvider.getCartonsList();
            this.frequencyProviders.getFrequencyList();
            break;
          case "list-target-achievements":
            this.currentAreaTitle = "Loyalty Target & Achievements";
            this.targetProvider.getTargetAchievementList();
            this.targetProvider.getTargetPageCount();
            // this.regionProviders.getAllCities();
            break;
          case "add-target-achievements":
            this.currentAreaTitle = "Add Target & Achievements";
            this.targetProvider.getTargetAchievementList();
            this.targetProvider.getTargetPageCount();
            this.regionProviders.getRegionList();
            this.stateProvider.getStateList();
            this.frequencyProviders.getFrequencyList();
            this.channelProviders.getAllChannels();
            this.geographyProviders.getGeographyList();
            this.unitsProvider.getUnitsList();
            this.rolesProvider.getUserRoles();
            // this.regionProviders.getAllCities();
            break;
          case "content-and-learning":
            this.channelProviders.getAllChannels();
            this.regionProviders.getRegionList();
            this.geographyProviders.getGeographyList();
            this.stateProvider.getStateList();
            break;
          case "content-and-learning_dashboard":
            this.currentAreaTitle = "content-and-learning";
            this.channelProviders.getAllChannels();
            this.regionProviders.getRegionList();
            this.rolesProvider.getUserRoles();
            this.stateProvider.getStateList();
            // this.regionProviders.getAllCities();
            break;
          case "geography":
            this.currentAreaTitle = "Geography";
            this.geographyProviders.getGeographyList();
            break;
          case "visibility-chiller-scheme":
            this.currentAreaTitle = "Geography";
            this.regionProviders.getRegionList();
            this.stateProvider.getStateList();
            break;
          case "visibility-audit-types":
            this.currentAreaTitle = "Posm Audit Types";
            this.channelProviders.getAllChannels();
            this.regionProviders.getRegionList();
            this.stateProvider.getStateList();
            this.visibilityProvider.getVisibilityList();
            break;
          case "cooler-templates":
            this.currentAreaTitle = "Posm Audit Types";
            this.channelProviders.getAllChannels();
            this.regionProviders.getRegionList();
            this.stateProvider.getStateList();
            this.visibilityProvider.getVisibilityList();
            break;
          case "visibility-template":
            this.channelProviders.getAllChannels();
            this.regionProviders.getRegionList();
            this.stateProvider.getStateList();
            this.visibilityProvider.getVisibilityList();
            break;
          case "cooler-template":
            this.channelProviders.getAllChannels();
            this.regionProviders.getRegionList();
            this.stateProvider.getStateList();
            this.visibilityProvider.getVisibilityList();
            break;
          case "units":
            this.currentAreaTitle = "Units";
            this.unitsProvider.getUnitsList();
            break;
          case "create-visits":
            this.currentAreaTitle = "Create Visits";
            this.channelProviders.getAllChannels();
            this.regionProviders.getRegionList();
            this.geographyProviders.getGeographyList();
            break;
          case "user-management":
            this.currentAreaTitle = "Users";
            this.channelProviders.getAllChannels();
            this.regionProviders.getRegionList();
            this.geographyProviders.getGeographyList();
            this.rolesProvider.getUserRoles();
            this.stateProvider.getStateList();
            // this.regionProviders.getAllCities();
            break;
          case "create-mystery-shopper":
            this.currentAreaTitle = "Users";
            this.channelProviders.getAllChannels();
            this.regionProviders.getRegionList();
            this.geographyProviders.getGeographyList();
            this.rolesProvider.getUserRoles();
            this.stateProvider.getStateList();
            // this.regionProviders.getAllCities();
            break;
          case "user-points":
            this.currentAreaTitle = "User Points";
            this.channelProviders.getAllChannels();
            this.regionProviders.getRegionList();
            this.geographyProviders.getGeographyList();
            this.rolesProvider.getUserRoles();
            this.stateProvider.getStateList();
            // this.regionProviders.getAllCities();
            break;
          case "cities":
            this.currentAreaTitle = "cities";
            this.regionProviders.getRegionList();
            this.regionProviders.getAllCities();
            break;
          case "visibility-submissions":
            this.currentAreaTitle = "Visibility Submissions";
            this.regionProviders.getRegionList();
            this.channelProviders.getAllChannels();
            this.geographyProviders.getGeographyList();
            this.stateProvider.getStateList();
            this.cityProvider.getCityList();
            break;
          case "mobile-change-report":
            this.currentAreaTitle = "CSM Mobile Number Change Log Report";
            this.regionProviders.getRegionList();
            this.channelProviders.getAllChannels();
            this.geographyProviders.getGeographyList();
            this.stateProvider.getStateList();
            this.stateProvider.getUserList();
            break;
          case "user-report":
            this.currentAreaTitle = "Account Login Report";
            this.regionProviders.getRegionList();
            this.channelProviders.getAllChannels();
            this.geographyProviders.getGeographyList();
            this.stateProvider.getStateList();
            this.stateProvider.getUserList();
            break;
          case "enrollment-detailed-report":
            this.currentAreaTitle = "Enrollement Detailed Report";
            this.regionProviders.getRegionList();
            this.channelProviders.getAllChannels();
            this.geographyProviders.getGeographyList();
            this.stateProvider.getStateList();
            this.stateProvider.getUserList();
            break;
          case "bud4trade-report":
            this.regionProviders.getRegionList();
            this.channelProviders.getAllChannels();
            this.geographyProviders.getGeographyList();
            this.stateProvider.getStateList();
            this.stateProvider.getUserList();
            break;
          case "mystery-report":
            this.regionProviders.getRegionList();
            this.channelProviders.getAllChannels();
            this.geographyProviders.getGeographyList();
            this.stateProvider.getStateList();
            this.stateProvider.getUserList();
            break;
          case "redmeption-report":
            this.regionProviders.getRegionList();
            this.channelProviders.getAllChannels();
            this.geographyProviders.getGeographyList();
            this.stateProvider.getStateList();
            this.stateProvider.getUserList();
            break;
          case "target-achievement-report":
            this.regionProviders.getRegionList();
            this.channelProviders.getAllChannels();
            this.geographyProviders.getGeographyList();
            this.stateProvider.getStateList();
            this.stateProvider.getUserList();
            break;
          case "complied-state-report":
            this.regionProviders.getRegionList();
            this.channelProviders.getAllChannels();
            this.geographyProviders.getGeographyList();
            this.stateProvider.getStateList();
            this.stateProvider.getUserList();
            break;
          case "end-of-month-report":
            this.regionProviders.getRegionList();
            this.channelProviders.getAllChannels();
            this.geographyProviders.getGeographyList();
            this.stateProvider.getStateList();
            this.stateProvider.getUserList();
            break;
          case "live-report":
            this.regionProviders.getRegionList();
            this.channelProviders.getAllChannels();
            this.geographyProviders.getGeographyList();
            this.stateProvider.getStateList();
            this.stateProvider.getUserList();
            break;
          case "dau-time-report":
            this.regionProviders.getRegionList();
            this.channelProviders.getAllChannels();
            this.geographyProviders.getGeographyList();
            this.stateProvider.getStateList();
            this.stateProvider.getUserList();
            break;
          case "engagement-time-report":
            this.regionProviders.getRegionList();
            this.channelProviders.getAllChannels();
            this.geographyProviders.getGeographyList();
            this.stateProvider.getStateList();
            this.stateProvider.getUserList();
            break;
          case "mau-time-report":
            this.regionProviders.getRegionList();
            this.channelProviders.getAllChannels();
            this.geographyProviders.getGeographyList();
            this.stateProvider.getStateList();
            this.stateProvider.getUserList();
            break;
          case "module-time-report":
            this.regionProviders.getRegionList();
            this.channelProviders.getAllChannels();
            this.geographyProviders.getGeographyList();
            this.stateProvider.getStateList();
            this.stateProvider.getUserList();
            break;
          case "scheme-report":
            this.regionProviders.getRegionList();
            this.channelProviders.getAllChannels();
            this.geographyProviders.getGeographyList();
            this.stateProvider.getStateList();
            this.stateProvider.getUserList();
            break;
          case "uplift-report":
            this.regionProviders.getRegionList();
            this.channelProviders.getAllChannels();
            this.geographyProviders.getGeographyList();
            this.stateProvider.getStateList();
            this.stateProvider.getUserList();
            break;
          case "leaderborad-report":
            this.regionProviders.getRegionList();
            this.channelProviders.getAllChannels();
            this.geographyProviders.getGeographyList();
            this.stateProvider.getStateList();
            this.stateProvider.getUserList();
            break;
          case "other-report":
            this.regionProviders.getRegionList();
            this.channelProviders.getAllChannels();
            this.geographyProviders.getGeographyList();
            this.stateProvider.getStateList();
            this.stateProvider.getUserList();
            break;
          case "redemption-hub-report":
            this.regionProviders.getRegionList();
            this.channelProviders.getAllChannels();
            this.geographyProviders.getGeographyList();
            this.stateProvider.getStateList();
            this.stateProvider.getUserList();
            break;
          case "point-expiry-rules":
            this.currentAreaTitle = "Point Expiry Rules";
            this.channelProviders.getAllChannels();
            this.regionProviders.getRegionList();
            this.stateProvider.getStateList();
            break;
          case "add-edit-point-expiry-rule":
            this.channelProviders.getAllChannels();
            this.regionProviders.getRegionList();
            this.stateProvider.getStateList();
            break;
          case "gap-analysis":
            this.regionProviders.getRegionList();
            this.channelProviders.getAllChannels();
            this.stateProvider.getStateList();
            break;
          case "menu-spoc-email":
            this.regionProviders.getRegionList();
            this.channelProviders.getAllChannels();
            this.stateProvider.getStateList();
            break;
          case "add-edit-mystery-template":
            this.currentAreaTitle = "Mystery Template Configurations";
            this.channelProviders.getAllChannels();
            this.regionProviders.getRegionList();
            this.geographyProviders.getGeographyList();
            this.rolesProvider.getUserRoles();
            this.stateProvider.getStateList();
            break;
          case "add-crown-target":
            this.frequencyProviders.getFrequencyList();
            break;
        }
        break;
    }
  }
}
